<script setup lang="ts">
import { en, th } from '@nuxt/ui/locale'

const colorMode = useColorMode()

const color = computed(() => colorMode.value === 'dark' ? '#020618' : 'white')

const { locale } = useI18n()
// Nuxt UI's built-in strings (e.g. SelectMenu "Create", "No data") follow the app language.
const uiLocale = computed(() => locale.value === 'th' ? th : en)
const route = useRoute()
const { siteUrl } = useRuntimeConfig().public
// Query strings stay out so filtered/tracked variants collapse to one URL.
const canonicalUrl = computed(() => `${siteUrl}${route.path === '/' ? '/' : route.path.replace(/\/$/, '')}`)

useHead({
  meta: [
    { charset: 'utf-8' },
    { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    { key: 'theme-color', name: 'theme-color', content: color }
  ],
  link: [
    { rel: 'icon', href: '/favicon.ico', sizes: '32x32' },
    { rel: 'icon', href: '/favicon.svg', type: 'image/svg+xml' },
    { rel: 'apple-touch-icon', href: '/apple-touch-icon.png' },
    { key: 'canonical', rel: 'canonical', href: canonicalUrl }
  ],
  htmlAttrs: {
    lang: locale
  }
})

useSeoMeta({
  titleTemplate: '%s - Robot Realm',
  twitterCard: 'summary_large_image',
  ogUrl: canonicalUrl
})

</script>

<template>
  <UApp :locale="uiLocale">
    <NuxtLoadingIndicator />

    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>

    <LineFab />

    <AssumeBanner />

    <AnalyticsConsentBanner />
  </UApp>
</template>
